import { render, staticRenderFns } from "./interviews.vue?vue&type=template&id=feca09c8&scoped=true"
import script from "./interviews.vue?vue&type=script&lang=ts"
export * from "./interviews.vue?vue&type=script&lang=ts"
import style0 from "./interviews.vue?vue&type=style&index=0&id=feca09c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feca09c8",
  null
  
)

export default component.exports